import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../services/AuthService';

export default function GeneralChat() {
  const navigate = useNavigate();
  const [chatCode, setChatCode] = useState('');
  const [error, setError] = useState('');

  const handleGo = (e) => {
    e.preventDefault();
    const code = chatCode.trim();
    if (!code) { setError('Please enter a chat code.'); return; }
    // Chat codes are always 6 digits
    if (!/^\d{6}$/.test(code)) {
      setError('Chat code must be exactly 6 digits.');
      return;
    }
    navigate(`/chat/${code}`);
  };

  return (
    <div style={s.page}>
      {/* Top-right logout */}
      <button style={s.logoutBtn} onClick={() => { logout(); navigate('/'); }}>Logout</button>

      <div style={s.card}>
        {/* Icon */}
        <div style={s.iconWrap}>
          <svg width="52" height="52" viewBox="0 0 64 64" fill="none">
            <path d="M10 12h44a4 4 0 0 1 4 4v26a4 4 0 0 1-4 4H20l-12 8V16a4 4 0 0 1 4-4z"
              stroke="#00c8c8" strokeWidth="3.5" strokeLinejoin="round" fill="none"/>
            <circle cx="24" cy="27" r="3" fill="#00c8c8"/>
            <circle cx="32" cy="27" r="3" fill="#00c8c8"/>
            <circle cx="40" cy="27" r="3" fill="#00c8c8"/>
          </svg>
        </div>

        <h2 style={s.title}>General Chat</h2>
        <p style={s.sub}>Enter your chat code to join an existing session</p>

        {error && <div style={s.error}>{error}</div>}

        <form onSubmit={handleGo}>
          <input
            style={s.input}
            value={chatCode}
            onChange={e => { setChatCode(e.target.value); setError(''); }}
            placeholder="Enter chat code (e.g. 159067)"
            maxLength={6}
            autoFocus
          />
          <button type="submit" style={s.btn}>Go To Chat →</button>
        </form>

        <button style={s.backBtn} onClick={() => navigate('/dashboard')}>
          ← Back to Home
        </button>
      </div>
    </div>
  );
}

const s = {
  page:      { minHeight: '100vh', background: '#0d1117', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' },
  logoutBtn: { position: 'fixed', top: 16, right: 20, background: 'none', border: '1px solid #30363d', color: '#8b949e', padding: '6px 14px', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' },
  card:      { background: '#161b22', border: '1px solid #30363d', borderRadius: '14px', padding: 'clamp(28px,5vw,44px) clamp(20px,5vw,40px)', width: 380, maxWidth: '92vw', textAlign: 'center' },
  iconWrap:  { marginBottom: '20px' },
  title:     { color: '#e6edf3', fontSize: '22px', fontWeight: '700', margin: '0 0 8px' },
  sub:       { color: '#8b949e', fontSize: '14px', marginBottom: '28px' },
  input:     { width: '100%', padding: '12px 14px', background: '#0d1117', border: '1px solid #30363d', borderRadius: '8px', color: '#e6edf3', fontSize: '18px', textAlign: 'center', letterSpacing: '6px', outline: 'none', boxSizing: 'border-box', marginBottom: '14px' },
  btn:       { width: '100%', padding: '12px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '600', cursor: 'pointer', marginBottom: '12px' },
  backBtn:   { background: 'none', border: '1px solid #30363d', color: '#8b949e', padding: '9px 20px', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', width: '100%' },
  error:     { background: '#da363322', border: '1px solid #da3633', color: '#f85149', padding: '10px', borderRadius: '6px', fontSize: '13px', marginBottom: '16px' },
};
